import { determineAPIUrl } from 'shared/utils/determine-api-url.util';

const DEFAULT_CONFIG = {
  apiUrl: 'http://localhost:4000',
};
const API_URL = determineAPIUrl() || DEFAULT_CONFIG.apiUrl;

export default { API_URL };
